module.exports = __webpack_public_path__ + "img/special_33.7bfb2d37.png";